<template>
  <div>
    <div class="container mt-4 container-iframe">
      <div class="scroll-container">
        <ScrollComponent @scroll-end="handleScrollEnd" />
      </div>
    </div>

    <div class="container mt-0 text-center" style="margin-top: -80px">
      <p>
        Declaro mi total conformidad con las condiciones generales para la
        contratación del seguro solicitado, así como el aviso de privacidad.
      </p>
      <button
        class="btn btn-rounded float-right mb-3 col-3"
        data-bs-target="#avisoPrivacidadModal"
        @click="sendTerminos"
        data-bs-toggle="modal"
        :disabled="scrollIFrame"
      >
        Acepto
      </button>
    </div>

    <!-- modal -->
    <div
      class="modal fade"
      id="avisoPrivacidadModal"
      tabindex="-1"
      aria-labelledby="avisoPrivacidadModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <img
              src="./../../assets/img/Logo-Latino-Seguros_Mesa.png"
              alt="Logo Latino Seguros"
              class="img-fluid"
              style="height: 300px"
            />
            <div class="text-center mb-4 mt-3 pl-3 pr-3">
              <p>{{ text }}</p>
            </div>
            <button
              v-if="btnAceptar"
              type="button"
              class="col-3 btn btn-sm btn-primary btn-rounded"
              data-bs-dismiss="modal"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>
<script>
import Loading from "../sasp/tools/loading.vue";
import ScrollComponent from "../../componentes/condiciones-generales/ScrollComponent.vue";

export default {
  components: { Loading, ScrollComponent },
  data() {
    return {
      params: this.$route.params.id,
      id: "",
      renovacion: "",
      text: "",
      ifIcono: "",
      modal: false,
      isLoading: false,
      scrollIFrame: true,
      ifScroll: true,
      btnAceptar: true,
      location: {
        latitude: null,
        longitude: null,
      },
      error: null,
      modalInstance: null,
      showCloseButton: false,
    };
  },
  beforeDestroy() {
    // Remover el listener cuando se destruya el componente
    window.removeEventListener("message", this.handleScrollEnd);
  },
  methods: {
    handleScrollEnd(event) {
      this.scrollIFrame = false;
    },
    reload() {
      this.modal = false;
      window.location.reload();
    },
    //Cuando renovaccion es 0
    async aceptarRenovaO() {
      if (this.location.latitude == null) {
        const modal = new bootstrap.Modal(
          document.getElementById("avisoPrivacidadModal")
        );
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        modal.show(); // Muestra el modal
        this.text = "Es necesario confirmar los permisos de ubicación.";
        this.btnAceptar = true;
        return;
      }
      this.isLoading = true;
      const payload = {
        metodo: "GUARDARACEPTACIONTERMINO",
        data: {
          COTIZACION: this.id,
          ACEPTO: true,
          LOCALIZACION: `${this.location.latitude}, ${this.location.longitude}`,
          TELEFONO: "",
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          //console.log(res);
          const modal = new bootstrap.Modal(
            document.getElementById("avisoPrivacidadModal"),
            {
              backdrop: "static",
              keyboard: false,
            }
          );
          modal.show(); // Muestra el modal
          this.text =
            "Gracias por aceptar las condiciones generales, ya puedes continuar con la contratación de tu póliza.";
          this.btnAceptar = false;
          this.isLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
      this.isLoading = false;
    },
    //Cuando renovaccion es 1
    async aceptarRenovaU() {
      if (this.location.latitude == null) {
        const modal = new bootstrap.Modal(
          document.getElementById("avisoPrivacidadModal")
        );
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        modal.show(); // Muestra el modal
        this.text = "Es necesario confirmar los permisos de ubicación.";
        this.btnAceptar = true;
        return;
      }
      this.isLoading = true;
      const payload = {
        metodo: "GUARDAREMISIONRENOVACION",
        data: {
          COTIZACION: this.id,
          ACEPTO: true,
          LOCALIZACION: `${this.location.latitude}, ${this.location.longitude}`,
          TELEFONO: "",
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);

        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          let error = this.$store.getters.getDataRaw.errorMessage.split("|");
          console.log(error);
          if (res != "") {
            const modal = new bootstrap.Modal(
              document.getElementById("avisoPrivacidadModal"),
              {
                backdrop: "static",
                keyboard: false,
              }
            );
            modal.show(); // Muestra el modal
            this.modal = true;
            this.ifIcono = false;
            this.btnAceptar = false;
            this.text =
              "Gracias por aceptar tu póliza y las condiciones generales, \nte enviaremos la póliza a tu correo. \nTu poliza es: " +
              res.POLIZA;
            this.isLoading = false;
          } else if (res == "") {
            this.text = error[1];
            this.isLoading = false;
          }
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
      this.isLoading = false;
    },
    async consultaEstatus() {
      this.isLoading = true;
      const payload = {
        metodo: "CONSULTAESTAUSCONDICIONESAUTOS",
        data: {
          // COTIZACION: '999999953',
          COTIZACION: this.id,
          RAMO: "34",
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          let res = this.$store.getters.getRespuestaREST;
          // res = 'FALSE'
          if (res == "TRUE") {
            const modal = new bootstrap.Modal(
              document.getElementById("avisoPrivacidadModal"),
              {
                backdrop: "static",
                keyboard: false,
              }
            );
            modal.show(); // Muestra el modal
            this.text =
              "Gracias por aceptar las Condiciones Generales, no olvides realizar tu inspección.";
            this.modal = true;
            this.btnAceptar = false;
            this.showCloseButton = true;
            this.ifIcono = false;
            this.isLoading = false;
          } else {
            const modal = new bootstrap.Modal(
              document.getElementById("avisoPrivacidadModal"),
              {
                backdrop: "static",
                keyboard: false,
              }
            );
            modal.show(); // Muestra el modal
            this.text =
              "Por favor, desplázate hasta el final de las Condiciones Generales para habilitar el botón de aceptación.";
            this.modal = true;
            this.btnAceptar = true;
            this.showCloseButton = true;
            this.ifIcono = false;
            this.isLoading = false;
          }
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
      this.isLoading = false;
    },
    sendTerminos() {
      if (this.renovacion == 0) {
        this.aceptarRenovaO();
        //console.log("Entra 0");
        return;
      }

      if (this.renovacion == 1) {
        this.aceptarRenovaU();
        //console.log("Entra 1");
        return;
      }
    },
    getLocation() {
      if (navigator.geolocation) {
        // Solicita la ubicación
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // Almacena la latitud y longitud
            this.location.latitude = position.coords.latitude;
            this.location.longitude = position.coords.longitude;
            // Imprime la ubicación en la consola
            //console.log("Latitud:", this.location.latitude);
            //console.log("Longitud:", this.location.longitude);
            this.consultaEstatus();
            this.error = null;
          },
          (error) => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.error = "Permiso denegado para obtener ubicación.";
                break;
              case error.POSITION_UNAVAILABLE:
                this.error = "La información de ubicación no está disponible.";
                break;
              case error.TIMEOUT:
                this.error = "La solicitud para obtener la ubicación expiró.";
                break;
              case error.UNKNOWN_ERROR:
                this.error = "Ocurrió un error desconocido.";
                break;
            }
            const modal = new bootstrap.Modal(
              document.getElementById("avisoPrivacidadModal")
            );
            document
              .querySelectorAll(".modal-backdrop")
              .forEach((el) => el.remove());
            modal.show();
            this.text = "Es necesario confirmar los permisos de ubicación.";
            this.btnAceptar = true;
          }
        );
      } else {
        // Si la API no está disponible
        this.error = "La geolocalización no es compatible con este navegador.";
      }
    },
  },
  async mounted() {
    await this.getLocation();
    //para obtener los parametros de la url separados
    var splt = this.params.split("&");
    this.id = splt[0].replace(/[^0-9]+/g, "");
    //console.log(this.id);
    this.renovacion = splt[1].replace(/[^0-9]+/g, "");
  },
};
</script>

<style>
.container-iframe {
  width: 100%;
  height: 75vh !important;
  margin-top: 0px;
}

iframe {
  width: 100% !important;
  height: 100% !important;
}
.textModal {
  font-family: Century Gothic, CenturyGothic, AppleGothic, sans-serif;
  font-size: 15px;
  color: #022341;
}
.btn-rounded {
  border-radius: 10px;
  background-color: #01427a;
  color: white;
}
.item {
  height: 100px;
}
.elemento {
  margin-top: 10px;
  overflow: scroll;
  height: 500px;
  width: 100%;
  align-content: center;
}
body {
  height: 100%;
  background: #ffffff;
}
button {
  margin-right: 10px;
}

.scroll-container {
  display: flex;
  flex-direction: column;
  height: 65vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: 1px solid black;
}

@media (max-width: 768px) {
.container-iframe {
  width: 100%;
  height: 65vh !important;
  margin-top: 0px;
}
  .scroll-container {
  display: flex;
  flex-direction: column;
  height: 60vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
  border: 1px solid black;
}
}

@media (max-height: 820px) and (max-width: 768px) {
  .container-iframe {
    width: 100%;
    height: 75vh !important;
    margin-top: 0px;
  }

  .scroll-container {
    display: flex;
    flex-direction: column;
    height: 70vh; 
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 1px solid black;
  }
}
</style>